export default "__VITE_ASSET__Y4YRO2UV__"